export default "__VITE_ASSET__CKYAyjkN__"